module.exports = __webpack_public_path__ + "static/media/moments.88d8087f.svg";